import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";
import { usePeopleSearch } from "@/contexts/PeopleSearchContext";
import { ChipsInput } from "../ChipsInput";
import { TimeframeToggle } from "../TimeframeToggle";

// Employer names are free text inside candidate_experiences.metadata — dedupe client-side
async function getCompanySuggestions(query: string): Promise<string[]> {
	// @ts-ignore - table exists but types not yet regenerated
	const { data, error } = await supabase
		.from('candidate_experiences')
		.select('metadata->>company')
		.ilike('metadata->>company', `%${query}%`)
		.limit(50);
	if (error) return [];
	const names = new Set<string>();
	// @ts-ignore - untyped rows from stale generated types
	for (const row of data || []) {
		const name = row.company;
		if (typeof name === 'string' && name.trim() !== '')
			names.add(name.trim());
	}
	return Array.from(names).slice(0, 10);
}

export function CompanyPanel() {
	const { t } = useTranslation();
	const { draft, updateDraft } = usePeopleSearch();

	return (
		<div className="space-y-4">
			<p className="text-sm text-muted-foreground">
				{t("peopleSearch.company.hint", "Candidates who work or worked at any of these companies")}
			</p>
			<ChipsInput
				values={draft.company.names}
				onChange={names => updateDraft('company', { ...draft.company, names })}
				placeholder={t("peopleSearch.company.placeholder", "Choose companies")}
				getSuggestions={getCompanySuggestions}
			/>
			<TimeframeToggle
				value={draft.company.timeframe}
				onChange={timeframe => updateDraft('company', { ...draft.company, timeframe })}
			/>
		</div>
	);
}
